import React from 'react';
import UpperBodyFashionCatalogueWorkflow from '../ecommerce-photoshoot/UpperBodyFashionCatalogueWorkflow';
import { GYM_WEAR_CATALOGUE_CONFIG } from '../ecommerce-photoshoot/catalogueWorkflowConfigs';

const GymWearPhotoshoot: React.FC = () => (
  <UpperBodyFashionCatalogueWorkflow
    config={GYM_WEAR_CATALOGUE_CONFIG}
    onBackToWorkflows={() => window.history.back()}
  />
);

export default GymWearPhotoshoot;
